/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagedetailfee3Inputs */

const en_ticketpagedetailfee3 = /** @type {(inputs: Ticketpagedetailfee3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket fee`)
};

const de_ticketpagedetailfee3 = /** @type {(inputs: Ticketpagedetailfee3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketgebühr`)
};

/**
* | output |
* | --- |
* | "Ticket fee" |
*
* @param {Ticketpagedetailfee3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagedetailfee3 = /** @type {((inputs?: Ticketpagedetailfee3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagedetailfee3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagedetailfee3(inputs)
	return de_ticketpagedetailfee3(inputs)
});
export { ticketpagedetailfee3 as "ticketPageDetailFee" }